export default "__VITE_ASSET__Cnu1nmK0__"